import { languageService } from "../../../../Language/language.service";
import { dataFormatters } from "../../../../utils/dataFormatters";
import { TableCellScrollable } from "../../Helper/TableUtils";
import React from "react";

export const hosCommingledServiceCommentsTableSchema = [
  {
    Header: languageService("Start Date & Time"),
    id: "startDate",
    accessor: "startDate",
    Cell: (d) => dataFormatters.dateTimeFormatterWithTimezone(d.value, d.original.timezone, true),
    minWidth: 200,
  },
  {
    Header: languageService("End Date & Time"),
    id: "endDate",
    accessor: "endDate",
    Cell: (d) => dataFormatters.dateTimeFormatterWithTimezone(d.value, d.original.timezone, true),
    minWidth: 200,
  },
  {
    Header: languageService("Comments"),
    accessor: "comments",
    id: "comments",
    minWidth: 600,
    Cell: TableCellScrollable,
  },
];



// WEBPACK FOOTER //
// ./src/components/HoursOfService/MyHoursOfService/schemas/hosCommingledServiceCommentsTableSchema.js